import { pick } from 'lodash'
import store from '../store'
import { http } from './http'
import { deepMergeAxios, addHeadersIdToHitInterface } from './dept-api-code-trace'
import { mapDepts } from '../components/query-table/utils'
import { random } from './common'


// 首页菜单id
const HOME_MENU_ID = '2820215716730110'

// 权限组织树接口的headers头参数
const AXIOS = {
  axios: {
    headers: {
      'X-menu-id': HOME_MENU_ID
    }
  }
}

let hasAllTreeAuth = false
const KEYS = [
  'name', // 组织名
  'departmentRoute', // 组织路径
  'departmentIdRoute', // 组织id路径
  'departmentCode', // 编码
  'id', // 组织id
  'ids', // 当前组织子级
  'chargeId', // 组织负责人id
  'chargeName', // 组负责人姓名
  'parentId', // 父节点
  'level', // 层级
  'children' // 当前子集
]

let storeOrg = {
  deptMap: null, // 组织id映射
  data: null, // 全量数组树
  ruleIds: null, // 非公共组织数据权限规则menuId集合
}

// 白名单
const getAllTreeAuth = () => {
  if (hasAllTreeAuth !== null) {
    return hasAllTreeAuth
  }
  const number = store.getters.user.employeeNumber
  const arr = store.getters.lookUpOptions['hrms_department_lookup'] || []
  hasAllTreeAuth = arr.some(e => e.value === number)
  return hasAllTreeAuth
}

// const setOrgData = (arr = []) => {
//   arr.forEach(item => {
//     if (!Object.keys(storeOrg.deptMap).includes(item.id)) {
//       storeOrg.deptMap[item.id] = item
//     }
//   })
// }

// // 批量获特殊组织权限菜单id
// const getOrgAuthRuleIds = () => {
//   const url = 'auth.business.departmentTreeConfig.getCustomRuleResIds'

//   const data = storeOrg.ruleIds
//   if (Array.isArray(data)) {
//     return Promise.resolve(data)
//   }

//   return http(url, { time: random() }, { log: false, cancel: true })
//     .then(data => {
//       storeOrg.ruleIds = data || []
//       return data
//     })
// }


// 获取权限组织
const getAuthOrgTreeData = () => {
  const url = 'hr.department.refactoring.getAllDepartmentLeastAsTreeWithAuth'
  const axios = deepMergeAxios(AXIOS, addHeadersIdToHitInterface(url))

  return http(url, { time: random() }, axios)
    .then(data => {
      return data
    })
}

const reqestAllOrgTree = () => {
  const url = 'hr.department.refactoring.getAllSimpleAsTreeFast'
  const axios = deepMergeAxios(AXIOS, addHeadersIdToHitInterface(url))
  return http(url, { time: random() }, axios)
    .then(data => {
      const deptMap = mapDepts({}, data, data.children)
      storeOrg.data = data
      storeOrg.deptMap = Object.keys(deptMap).reduce((cur, id) => {
        cur[id] = pick(deptMap[id], KEYS)
        return cur
      }, {})
      return data
    })
}

// 获取全量组织树数据
const getAllOrgTreeData = (allTreeAuth = false) => {
  const hasAllTree = allTreeAuth || getAllTreeAuth()
  if (!hasAllTree) {
    return Promise.resolve(null)
  }

  const res = storeOrg.data
  if (res && res.id && res.parentId && res.children) {
    return Promise.resolve(res)
  }

  return reqestAllOrgTree()
}

const getAllOrgMap = () => {
  const res = storeOrg.deptMap

  if (res) {
    return Promise.resolve(res)
  }

  return reqestAllOrgTree().then(_ => {
    return storeOrg.deptMap
  })
}

const getOrgDataByAllOrg = (ids) => {
  return ids.map(id => storeOrg.deptMap[id])
}

// 通过组件id批量获取数据
const getOrgDataByIds = (ids = []) => {
  // const url = 'hr.remoteDepartment.list'

  // const isHasAll = ids.some(id => !Object.keys(storeOrg.deptMap).includes(id))
  // if (!isHasAll) {
  //   const data = ids.map(id => ({ ...pick(storeOrg.deptMap[id], KEYS) }))
  //   return Promise.resolve(data)
  // }

  // return http(url, { ids }, AXIOS)
  //   .then(data => {
  //     setOrgData(data)
  //     return data.map(v => ({ ...pick(v, KEYS) }))
  //   })
  const res = storeOrg.deptMap

  if (res) {
    return Promise.resolve(getOrgDataByAllOrg(ids))
  }

  return reqestAllOrgTree().then(_ => {
    return getOrgDataByAllOrg(ids)
  })
}

let deptApi = {
  getOrgDataByIds,
  getAuthOrgTreeData,
  getAllOrgMap,
  getAllOrgTreeData
}

let _deptApi

if (window.__ERP_PUBLIC_SHARED_DEPT__) {
  _deptApi = window.__ERP_PUBLIC_SHARED_DEPT__
} else {
  window.__ERP_PUBLIC_SHARED_DEPT__ = _deptApi = deptApi
}

export default _deptApi



// WEBPACK FOOTER //
// ./src/public/utils/dept-api.js